<template>
    <Layout>
        <el-main style="flex: 1;">
            <div style="margin-bottom: 20px;">
                <el-button-group>
                    <el-button
                        :disabled="selection.length === 0"
                        @click="changeVisible(true)"
                        type="primary"
                    >选择素材</el-button>
                    <el-button
                        :disabled="selection.length === 0"
                        @click="clickSyncConfig"
                        type="primary"
                    >同步配置</el-button>
                </el-button-group>
            </div>
            <Table />
            <Pagination />
        </el-main>
        <DialogResource :visible="visible" @on-close="changeVisible" />
    </Layout>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Layout from '../../main/layout';
import Table from './table';
import Pagination from './pagination';
import DialogResource from './dialog.resource';

const { mapState, mapActions } = createNamespacedHelpers('installDevice');

export default {
    components: { Layout, Table, Pagination, DialogResource },
    data() {
        return {
            visible: false,
        };
    },
    computed: {
        ...mapState({
            selection: state => state.selection,
        }),
        siteId() {
            return this.$route.query.siteId;
        },
    },
    methods: {
        ...mapActions(['getDevices']),
        changeVisible(value) {
            this.visible = value;
        },
        clickSyncConfig() {
            this.$message.info('同步配置。');
        },
    },
    mounted() {
        this.getDevices({ siteId: this.siteId });
    },
};
</script>
